module.exports = __webpack_public_path__ + "static/media/Learning.e266a22e.md";